import { useMemo } from 'react';
import {
  SidebarWrapper,
  AvatarWrapper,
  Avatar,
  SidebarMenu,
  Tab,
  StyledArrowRightIcon,
  EmptyAvatar,
} from './styles';
import Text, { TEXT_COLOR } from '@components/Text';
import { ROUTES } from '@shared/constants';
import { generatePath, useParams, useHistory } from 'react-router-dom';
import { NO_NAME, TABS } from '../../../consts';
import { useSelector } from 'react-redux';

export const Sidebar = ({ pageType }) => {
  const { id } = useParams();
  const { push } = useHistory();

  const { avatar, fullName } = useSelector((state) => state.getIn(['staffPage', 'userData']));

  const goToPage = (pageType) => () => {
    push(generatePath(ROUTES.STAFF.PAGE, { id, pageType }));
  }

  const firstLettersName = useMemo(() =>
    fullName && fullName.split(' ').map((name) => name.at(0))
  , [fullName]);

  return (
    <SidebarWrapper>
      <AvatarWrapper>
        {avatar
          ? <Avatar src={avatar} alt={`${fullName ?? NO_NAME}`} />
          : <EmptyAvatar>{firstLettersName}</EmptyAvatar>
        }
        <Text size="H1" textColor={TEXT_COLOR.DARK_BLUE}>
          {fullName ?? NO_NAME}
        </Text>
      </AvatarWrapper>
      <SidebarMenu>
        {TABS.map(({ type, title }) => (
          <Tab
            to={generatePath(ROUTES.STAFF.PAGE, { id, pageType: type })}
            onClick={goToPage(type)}
            active={pageType === type}
          >
          {title}
          {pageType === type && <StyledArrowRightIcon />}
        </Tab>
        ))}
      </SidebarMenu>
    </SidebarWrapper>
  );
};
